module.exports = __webpack_public_path__ + "img/zhjq1_image.834bd92d.png";